t = require('views/internal/teacup-with-helpers')('header_announcements')
renderAnnouncement = require './announcement'
socialUrls = require('locale').social

module.exports = t.renderable (announcements) ->
  announcements.forEach renderAnnouncement

  campaign =
    if announcements.length > 0 && (path = ///^https?://(?:[-a-z]+\.)?blog\.trello\.com/([^/]+)///.exec(announcements[0].url)?[1])?
      path
    else
      'none'

  if /\?/g.test(campaign)
    campaign = campaign.replace(/\?/gi, '&')

  blogQuery =
    "?utm_campaign=#{ campaign }"

  if !/utm_source/.test(campaign)
    blogQuery += '&utm_source=direct'

  if !/utm_medium/.test(campaign)
    blogQuery += '&utm_medium=inapp'

  t.div '.announcement-elsewhere', ->
    t.p '.quiet', { style: 'margin: 0 4px 5px;' }, ->
      t.format 'for-more-updates-check-out-ellipsis'

    t.a '.announcement-elsewhere-blog.js-blog', { target: '_blank', href: socialUrls.blog + blogQuery }, ->
      t.span '.announcement-elsewhere-blog-icon.icon-lg.icon-board'
      t.span '.u-text-underline', ->
        t.format 'trello-blog'

    t.a '.announcement-elsewhere-social.js-t', { target: '_blank', href: socialUrls.twitter }, ->
      t.span '.icon-lg.icon-twitter'

    t.a '.announcement-elsewhere-social.js-fb', { target: '_blank', href: socialUrls.facebook }, ->
      t.span '.icon-lg.icon-facebook'

    t.a '.announcement-elsewhere-social.js-i', { target: '_blank', href: socialUrls.instagram }, ->
      t.span '.icon-lg.icon-custom.icon-instagram'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_announcements.coffee